import React from 'react'

import Action from './Action.js'

import { receivedResponse } from '../h2Api'

const ActionButton = props => {
  const {
    request,
    requestMatch,
    loading,
    error,
    success,
    internal,
    loadOnly,
    children,
    className,
    ...rest
  } = props
  const isLoading =
    (loading === 'auto' && request && requestMatch(request) && request.loading) ||
    (loading !== 'auto' && loading)
  const errorMessage =
    (error === 'auto' && request && requestMatch(request) && request.error) ||
    (error !== 'auto' && error)
  const successMessage =
    (success === 'auto' &&
      request &&
      requestMatch(request) &&
      receivedResponse(request) &&
      'Done') ||
    (success !== 'auto' && success)
  const classNameForButton = `${className} ${isLoading ? 'button-loading' : ''}`
  const disabledAttribute = isLoading ? { disabled: true } : {}

  return (
    <Action loading={isLoading} error={errorMessage} success={successMessage}>
      {(loadingElement, messageElement, iconElement) => {
        if (internal || loadOnly) {
          return (
            <button className={classNameForButton} {...disabledAttribute} {...rest}>
              {children} {loadingElement || (!loadOnly && iconElement)}
            </button>
          )
        }

        return (
          <span>
            <button className={classNameForButton} {...disabledAttribute} {...rest}>
              {children} {loadingElement}
            </button>
            {messageElement}
          </span>
        )
      }}
    </Action>
  )
}

ActionButton.defaultProps = {
  error: 'auto',
  success: 'auto',
  loading: 'auto',
  internal: false,
  loadOnly: false,
  requestMatch: () => true
}

export default ActionButton
